module.exports = __webpack_public_path__ + "static/media/map-nederland.64a9a2e7.png";